<h1 id="title" class="title">Verifica tu cuenta</h1>
<p class="sub-title">Verifica cuenta ingresando al enlace de activaci&oacute;n enviado a tu correo electr&oacute;nico</p>

<nb-alert *ngIf="errors?.length && !submitted" outline="danger" role="alert">
  <p class="alert-title"><b>¡Oops!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<nb-alert *ngIf="messages?.length && !submitted" outline="success" role="alert">
  <p class="alert-title"><b>¡Listo!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
  </ul>
</nb-alert>

<form (ngSubmit)="sendVerificationEmail()" #form="ngForm" aria-labelledby="title">
  <button nbButton
          fullWidth
          status="primary"
          size="large"
          [disabled]="submitted || !form.valid"
          [class.btn-pulse]="submitted">
    Enviar de nuevo
  </button>
</form>
<div class="links">
    <small class="form-text">
        ¿Ya tienes cuenta verificada? <a routerLink="../login"><strong>Ingresa</strong></a>
    </small>
</div>